import SectionNavigation from '../SectionNavigation';

const ActivityTab = ({ config, productType }) => {
  const navigationItems = [
    { label: '活动总览', targetId: '#overview' },
    { label: '评测竞赛', targetId: '#competition' },
    { label: '创意评选', targetId: '#creative' },
  ];

  // 根据产品类型渲染不同的活动内容
  const renderActivityContent = () => {
    if (productType === 'GD32E231') {
      return (
        <div>
          {/* 活动总览 */}
          <div id="overview" className="py-2.5 pb-0 text-sm">
            <h3 className="text-base font-bold">活动总览</h3>

            {/* 时间线容器 */}
            <div className="relative h-[400px] pb-[30px]">
              {/* 时间线主轴 */}
              <div className="h-0.5 bg-[#0093E6] absolute top-[215px] left-0 right-0">
                {/* 节点 1 - 2019年3月上旬 */}
                <div className="absolute w-2.5 h-2.5 bg-[#0093E6] rounded-full top-1/2 -mt-[5px] left-[83px]">
                  <div className="w-0.5 h-[30px] bg-[#0093E6] absolute left-[49%] -top-[30px]"></div>
                  <div className="absolute w-[115px] h-7 rounded-[14px] bg-[#0093E6] -left-14 -top-12">
                    <p className="leading-7 text-center text-white text-sm">2019年3月上旬</p>
                  </div>
                  <div className="w-[234px] absolute text-[#666] -left-[50px] -top-[155px]">
                    <p className="relative ml-2.5 mb-2.5 leading-[22px] text-sm">
                      <i
                        className="block w-1 h-[7px] absolute -left-2.5 top-[7px]"
                        style={{
                          backgroundImage:
                            'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/sizetriangle.png)',
                        }}
                      />
                      3月12日，立创新媒体线下采访兆易创新公司。
                    </p>
                    <p className="relative ml-2.5 mb-2.5 leading-[22px] text-sm">
                      <i
                        className="block w-1 h-[7px] absolute -left-2.5 top-[7px]"
                        style={{
                          backgroundImage:
                            'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/sizetriangle.png)',
                        }}
                      />
                      3月18日，GD32E231的样品立创商城上线。
                    </p>
                  </div>
                </div>

                {/* 节点 2 - 2019年4月上旬 */}
                <div className="absolute w-2.5 h-2.5 bg-[#0093E6] rounded-full top-1/2 -mt-[5px] left-[459px]">
                  <div className="w-0.5 h-[30px] bg-[#0093E6] absolute left-[49%] -top-[30px]"></div>
                  <div className="absolute w-[115px] h-7 rounded-[14px] bg-[#0093E6] -left-14 -top-12">
                    <p className="leading-7 text-center text-white text-sm">2019年4月上旬</p>
                  </div>
                  <div className="w-[234px] absolute text-[#666] -left-[50px] -top-[105px]">
                    <p className="relative ml-2.5 mb-5 leading-[22px] text-sm">
                      <i
                        className="block w-1 h-[7px] absolute -left-2.5 top-[7px]"
                        style={{
                          backgroundImage:
                            'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/sizetriangle.png)',
                        }}
                      />
                      4月8日，&ldquo;创意评选&rdquo; 和 &ldquo;评测竞赛&rdquo; 的活动同步上线进行。
                    </p>
                  </div>
                </div>

                {/* 节点 3 - 2019年4月下旬 */}
                <div className="absolute w-2.5 h-2.5 bg-[#0093E6] rounded-full top-1/2 -mt-[5px] left-[821px]">
                  <div className="w-0.5 h-[30px] bg-[#0093E6] absolute left-[49%] -top-[30px]"></div>
                  <div className="absolute w-[115px] h-7 rounded-[14px] bg-[#0093E6] -left-14 -top-12">
                    <p className="leading-7 text-center text-white text-sm">2019年4月下旬</p>
                  </div>
                  <div className="w-[234px] absolute text-[#666] -left-[50px] -top-[105px]">
                    <p className="relative ml-2.5 mb-5 leading-[22px] text-sm">
                      <i
                        className="block w-1 h-[7px] absolute -left-2.5 top-[7px]"
                        style={{
                          backgroundImage:
                            'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/sizetriangle.png)',
                        }}
                      />
                      4月18日，工业控制运用元器件低至8折起，且支持 &ldquo;报价&rdquo; 服务
                    </p>
                  </div>
                </div>

                {/* 节点 4 - 2019年3月下旬 */}
                <div className="absolute w-2.5 h-2.5 bg-[#0093E6] rounded-full top-1/2 -mt-[5px] left-[262px]">
                  <div className="w-0.5 h-[30px] bg-[#0093E6] absolute left-[49%] top-[9px]"></div>
                  <div className="absolute w-[115px] h-7 rounded-[14px] bg-[#0093E6] -left-14 top-[30px]">
                    <p className="leading-7 text-center text-white text-sm">2019年3月下旬</p>
                  </div>
                  <div className="w-[234px] absolute text-[#666] -left-[50px] top-[80px]">
                    <p className="relative ml-2.5 mb-5 leading-[22px] text-sm">
                      <i
                        className="block w-1 h-[7px] absolute -left-2.5 top-[7px]"
                        style={{
                          backgroundImage:
                            'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/sizetriangle.png)',
                        }}
                      />
                      3月20日，兆易创新MCU市场总监金光易应邀参加穆尼黑上海展会立创商城站台现场
                    </p>
                  </div>
                </div>

                {/* 节点 5 - 2019年4月中旬 */}
                <div className="absolute w-2.5 h-2.5 bg-[#0093E6] rounded-full top-1/2 -mt-[5px] left-[677px]">
                  <div className="w-0.5 h-[30px] bg-[#0093E6] absolute left-[49%] top-[9px]"></div>
                  <div className="absolute w-[115px] h-7 rounded-[14px] bg-[#0093E6] -left-14 top-[30px]">
                    <p className="leading-7 text-center text-white text-sm">2019年4月中旬</p>
                  </div>
                  <div className="w-[234px] absolute text-[#666] -left-[50px] top-[80px]">
                    <p className="relative ml-2.5 mb-5 leading-[22px] text-sm">
                      <i
                        className="block w-1 h-[7px] absolute -left-2.5 top-[7px]"
                        style={{
                          backgroundImage:
                            'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/sizetriangle.png)',
                        }}
                      />
                      4月9日，深圳CITE展会现场展示GD32E231开发板
                    </p>
                  </div>
                </div>

                {/* 节点 6 - 2019年5月~6月 */}
                <div className="absolute w-2.5 h-2.5 bg-[#0093E6] rounded-full top-1/2 -mt-[5px] left-[967px]">
                  <div className="w-0.5 h-[30px] bg-[#0093E6] absolute left-[49%] top-[9px]"></div>
                  <div className="absolute w-[115px] h-7 rounded-[14px] bg-[#0093E6] -left-14 top-[30px]">
                    <p className="leading-7 text-center text-white text-sm">2019年5月~6月</p>
                  </div>
                  <div className="w-[234px] absolute text-[#666] -left-[50px] top-[80px]">
                    <p className="relative ml-2.5 mb-5 leading-[22px] text-sm">
                      <i
                        className="block w-1 h-[7px] absolute -left-2.5 top-[7px]"
                        style={{
                          backgroundImage:
                            'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/sizetriangle.png)',
                        }}
                      />
                      5月10日，活动揭晓；
                    </p>
                    <p className="relative ml-2.5 mb-5 leading-[22px] text-sm">
                      <i
                        className="block w-1 h-[7px] absolute -left-2.5 top-[7px]"
                        style={{
                          backgroundImage:
                            'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/sizetriangle.png)',
                        }}
                      />
                      6月5日，项目线下见面会。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 开发板Workshop */}
          <div id="competition" className="mb-8">
            <h3 className="text-base font-bold mb-2.5">开发板Workshop</h3>
            {config.activities?.competitions?.map((competition, index) => (
              <div key={index} className="border-dashed border-[#e4e4e4] rounded-[5px] py-[25px] px-5 box-border">
                <div className="float-left">
                  <div className="mb-2.5">
                    <div
                      className="block w-[137px] h-[35px]"
                      style={{
                        backgroundImage:
                          'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/index_icon_2.png)',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '-1px -50px',
                        fontStyle: 'normal',
                      }}
                    >
                      <p className="leading-[33px] text-white text-center pl-[40px]">活动说明</p>
                    </div>
                  </div>
                  <div className="mt-2.5">
                    <p className="leading-[26px]">活动时间：{competition.duration}</p>
                    <p className="font-extrabold leading-[26px]">参与方式：</p>
                    <p className="leading-[26px]">
                      <a href={competition.link} rel="nofollow" className="text-[#ff7800]">
                        1、点此进入立创社区&ldquo;{competition.title}&rdquo;
                      </a>
                    </p>
                    <p className="leading-[26px]">2、{competition.description}</p>
                  </div>
                </div>

                <div className="float-right mr-5">
                  <div className="mb-2.5">
                    <div
                      className="block w-[137px] h-[35px]"
                      style={{
                        backgroundImage:
                          'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/index_icon_2.png)',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '-1px -97px',
                        fontStyle: 'normal',
                      }}
                    >
                      <p className="leading-[33px] text-white text-center pl-[40px]">活动礼品</p>
                    </div>
                  </div>
                  <div className="mt-2.5">
                    {competition.prizes?.map((prize, prizeIndex) => (
                      <div key={prizeIndex} className="float-left w-[141px] leading-5 mr-7 mt-2.5 text-center relative">
                        <span
                          className={`absolute w-10 h-10 leading-10 text-center font-extrabold text-white left-[${prizeIndex === 0 ? '106px' : prizeIndex === 1 ? '97px' : '120px'}]`}
                          style={{
                            backgroundImage:
                              'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/index_icon_2.png)',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: '-93px 1px',
                          }}
                        >
                          {prize.count}
                        </span>
                        <img
                          src={`//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/${prize.image}`}
                          alt={prize.rank}
                          className="block mx-auto align-middle"
                        />
                        <p>{prize.rank}</p>
                        <p>{prize.prize}</p>
                      </div>
                    ))}
                    <div className="clear-both"></div>
                  </div>
                </div>
                <div className="clear-both"></div>
              </div>
            ))}
          </div>

          {/* 创意评选 */}
          <div id="creative" className="mb-8 mt-10">
            <h3 className="text-base font-bold mb-2.5">创意评选</h3>
            {config.activities?.creativeContests?.map((contest, index) => (
              <div key={index} className="border border-[#e4e4e4] rounded-[5px] py-[25px] px-5 box-border">
                <div className="float-left">
                  <div className="mb-2.5">
                    <div
                      className="block w-[137px] h-[35px]"
                      style={{
                        backgroundImage:
                          'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/index_icon_2.png)',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '-1px -50px',
                        fontStyle: 'normal',
                      }}
                    >
                      <p className="leading-[33px] text-white text-center pl-[40px]">活动说明</p>
                    </div>
                  </div>
                  <div className="mt-2.5">
                    <p className="leading-[26px]">活动时间：{contest.duration}</p>
                    <p className="leading-[26px]">
                      <a href={contest.link} rel="nofollow" className="text-[#ff7800]">
                        1、点此进入立创社区&ldquo;{contest.title}&rdquo;
                      </a>
                    </p>
                    <p className="leading-[26px]">2、{contest.description}</p>
                  </div>
                </div>

                <div className="float-right mr-5">
                  <div className="mb-2.5">
                    <div
                      className="block w-[137px] h-[35px]"
                      style={{
                        backgroundImage:
                          'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/index_icon_2.png)',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '-1px -97px',
                        fontStyle: 'normal',
                      }}
                    >
                      <p className="leading-[33px] text-white text-center pl-[40px]">活动礼品</p>
                    </div>
                  </div>
                  <div className="mt-2.5">
                    {contest.prizes?.map((prize, prizeIndex) => (
                      <div
                        key={prizeIndex}
                        className={`float-left w-[141px] leading-5 mr-7 mt-2.5 text-center relative ${prizeIndex === 2 ? 'ml-2.5' : ''}`}
                      >
                        <span
                          className={`absolute w-10 h-10 leading-10 text-center font-extrabold text-white left-[${prizeIndex === 0 ? '106px' : '125px'}]`}
                          style={{
                            backgroundImage:
                              'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/index_icon_2.png)',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: '-93px 1px',
                          }}
                        >
                          {prize.count}
                        </span>
                        <img
                          src={`//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/${prize.image}`}
                          alt={prize.rank}
                          className="block mx-auto align-middle"
                        />
                        <p>{prize.rank}</p>
                        <p>{prize.prize}</p>
                      </div>
                    ))}
                    <div className="clear-both"></div>
                  </div>
                </div>
                <div className="clear-both"></div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (productType === 'XILINXPYNQZ2') {
      return (
        <div>
          {/* 评测竞赛 */}
          <div id="competition" className="mb-8">
            <h3 className="text-base font-bold mb-2.5 text-[#444]">
              评测竞赛{'>>'}XILINX开发板PYNQ-Z2限量免费申请试用活动
            </h3>

            {config.activities?.competitions?.map((competition, index) => (
              <div key={index} className="mt-5 text-sm">
                {/* 活动说明 */}
                <div className="mb-5">
                  <div
                    className="inline-block w-[137px] h-[35px] text-center pl-5"
                    style={{
                      backgroundImage:
                        'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/index_icon_2.png)',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '-1px -50px',
                    }}
                  >
                    <p className="leading-[32px] text-white font-bold indent-[58px]" style={{ textIndent: 0 }}>
                      活动说明
                    </p>
                  </div>
                </div>

                <div className="leading-[2]">
                  <p className="mt-5">
                    <b className="text-[#DAA520]">活动时间：</b>
                    {competition.duration}
                  </p>
                  <p>
                    <b className="text-[#DAA520]">参与流程：</b>
                  </p>
                  <p>1. 扫描下面二维码，提交申请表格《关于XILINX开发板PYNQ-Z2限量免费申请试用活动》；</p>

                  {/* 二维码 */}
                  <div className="mt-1.5 pl-[280px]">
                    <img
                      src={`//static.szlcsc.com/ecp/assets/web/page/www/xinpinXILINXPYNQZ2/images/${competition.qrCode}`}
                      alt="报名二维码"
                    />
                    <a
                      href={competition.link}
                      className="block w-[135px] h-8 leading-8 text-center rounded-[3px] text-white bg-[#0094E7] text-sm font-bold hover:opacity-60"
                    >
                      点击打开报名链接
                    </a>
                  </div>

                  <p>
                    2.
                    活动方不定期筛选（正确完整提交申请表格者，均有机会），筛选并累计达到10个试用者后，活动方将线下通知试用者；
                  </p>
                  <p>3. 试用者缴纳押金500RMB（开发部PYNQ-Z2商城销售价格950RMB）；</p>
                  <p>4. 活动方收到押金后，开机验证试用板，合格后顺丰寄送；</p>
                  <p>5. 试用者收到开发板2个工作日（含当天）内开机验证（否则默认开发板正常）；</p>
                  <p>
                    6. 试用者收到开发板卡后，进行学习评估，并在论坛发帖（
                    <a className="inline text-blue-500" rel="nofollow" href="http://club.szlcsc.com/forum/128_0_1.html">
                      http://club.szlcsc.com/forum/128_0_1.html
                    </a>
                    ）记录板卡的试用过程、分享试用心得（时限：3周）。
                  </p>
                  <p className="indent-[15px]">
                    <b>试用标题要求：</b>【XILINX开发板试用报告】项目名称或描述XXX。
                  </p>
                  <p className="indent-[15px]">
                    <b>内容必须包括：</b>
                  </p>
                  <p className="indent-[45px]">
                    --开箱评测（从功能特性、系统框图、硬件资源、做工、软件资源、功能演示等方面评测）
                  </p>
                  <p className="indent-[45px]">--板卡各模块的使用和应用经验；</p>
                  <p className="indent-[45px]">--板卡的应用；</p>
                  <p className="indent-[15px]">
                    <b>项目标题要求：</b>【XILINX开发板运用报告】项目名称或描述XXX。
                  </p>
                  <p className="indent-[15px]">
                    <b>内容必须包括：</b>
                  </p>
                  <p className="indent-[45px]">--运用方案介绍（介绍PYNQ-Z2开发板所设计的方案及主要功能）</p>
                  <p className="indent-[45px]">--运用方案的系统框图（示意图，输入输出等）；</p>
                  <p className="indent-[45px]">
                    --照片示例和功能的实现（介绍功能实现的步骤，并配对应的图片，包括软件流程等）；
                  </p>
                  <p className="indent-[45px]">--代码分享（粘贴部分代码，主要以压缩包的形式）；</p>
                  <p>7. 试用者提交试用报告并顺丰到付寄回活动方（项目运用报告，开发板暂不寄出）。</p>
                  <p>8. 活动方收到板子2个工作日内验收，验收合格后退还押金。</p>
                </div>

                {/* 试用者激励方案 */}
                <div className="mt-[50px]">
                  <div
                    className="inline-block w-[176px] h-8"
                    style={{
                      backgroundImage:
                        'url(//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/xinpinactivity03.jpg)',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                    }}
                  >
                    <p className="leading-8 text-white font-bold indent-[58px]">试用者激励方案</p>
                  </div>
                </div>

                {/* 奖励内容 */}
                <div className="mt-5 py-[25px] px-5 text-sm bg-[#FFF9ED]">
                  {competition.rewards?.map((reward, rewardIndex) => (
                    <div key={rewardIndex} className={rewardIndex > 0 ? 'mt-10' : ''}>
                      <div className="w-[126px] h-8 leading-8 text-center text-base font-bold text-white bg-[#FF7800]">
                        {reward.type}
                      </div>
                      <p className="text-base leading-[2]">{reward.description}</p>
                      <img
                        src={`//static.szlcsc.com/ecp/assets/web/page/www/xinpinXILINXPYNQZ2/images/${reward.image}`}
                        alt={reward.type}
                      />
                      <p className="leading-[2]">
                        <b className="text-[#DAA520]">获奖要求：</b>
                        {reward.requirement}
                      </p>
                    </div>
                  ))}

                  <p className="leading-[2]">注：</p>
                  <p className="leading-[2]">1、本活动为立创商城和赛灵思共同策划和执行。</p>
                  <p className="leading-[2]">2、未尽事宜和活动最终解释权归立创商城所有。</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    // 默认内容 - 适用于其他产品类型
    return (
      <div className="py-10 px-5 text-center bg-gray-50 rounded-lg my-5">
        <h3 className="text-gray-600 mb-2">活动相关</h3>
        <p className="text-gray-400 text-sm">活动相关内容将在后续版本中完善</p>
      </div>
    );
  };

  return (
    <div className="block">
      <SectionNavigation items={navigationItems} />
      {renderActivityContent()}
    </div>
  );
};

export default ActivityTab;
